<template>
  <v-content>
    <Header/>
    <div class="main-container">
      <router-view/>
    </div>
    <Footer/>
  </v-content>
</template>

<script>
import Header from "./components/HeaderBlank";
import Footer from "./components/Footer";

export default {
  name: "home",
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="scss" scoped>
</style>
